/**
 * Event Builder icons — inline SVG, 24×24 viewBox, stroke 1.8, round caps/joins (plan 5.3 rule 6,
 * paths from Appendix D; the extra ones are drawn in the same lucide-style family).
 */

import React from "react";

const ICONS = {
  sparkle: [
    <path key="a" d="m12 3 1.2 4.1L17 9l-3.8 1.9L12 15l-1.2-4.1L7 9l3.8-1.9L12 3Z" />,
    <path key="b" d="m19 15 .7 2.3L22 18.5l-2.3 1.2L19 22l-.7-2.3-2.3-1.2 2.3-1.2L19 15Z" />,
  ],
  calendar: [<rect key="a" x="3" y="5" width="18" height="16" rx="2" />, <path key="b" d="M16 3v4M8 3v4M3 10h18" />],
  users: [<circle key="a" cx="9" cy="8" r="4" />, <path key="b" d="M2 21a7 7 0 0 1 14 0M17 11a4 4 0 0 1 0 8M17 4a4 4 0 0 1 0 7" />],
  message: [<path key="a" d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z" />, <path key="b" d="M8 9h8M8 13h5" />],
  bell: [<path key="a" d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />, <path key="b" d="M10 21h4" />],
  chevron: [<path key="a" d="m9 18 6-6-6-6" />],
  "chevron-down": [<path key="a" d="m6 9 6 6 6-6" />],
  "arrow-left": [<path key="a" d="m15 18-6-6 6-6" />, <path key="b" d="M9 12h11" />],
  eye: [<path key="a" d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />, <circle key="b" cx="12" cy="12" r="2.5" />],
  check: [<path key="a" d="m5 12 4 4L19 6" />],
  clock: [<circle key="a" cx="12" cy="12" r="9" />, <path key="b" d="M12 7v5l3 2" />],
  video: [<rect key="a" x="3" y="6" width="13" height="12" rx="2" />, <path key="b" d="m16 10 5-3v10l-5-3" />],
  link: [
    <path key="a" d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.1 1" />,
    <path key="b" d="M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.1-1" />,
  ],
  card: [<rect key="a" x="2" y="5" width="20" height="14" rx="2" />, <path key="b" d="M2 10h20M6 15h4" />],
  shield: [<path key="a" d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z" />],
  "shield-check": [<path key="a" d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z" />, <path key="b" d="m9 12 2 2 4-4" />],
  mail: [<rect key="a" x="3" y="5" width="18" height="14" rx="2" />, <path key="b" d="m3 7 9 6 9-6" />],
  phone: [
    <path key="a" d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" />,
  ],
  send: [<path key="a" d="m22 2-7 20-4-9-9-4 20-7Z" />, <path key="b" d="M22 2 11 13" />],
  copy: [<rect key="a" x="9" y="9" width="12" height="12" rx="2" />, <path key="b" d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />],
  pin: [<path key="a" d="M12 21s7-6.5 7-11.5a7 7 0 1 0-14 0C5 14.5 12 21 12 21Z" />, <circle key="b" cx="12" cy="9.5" r="2.5" />],
  globe: [<circle key="a" cx="12" cy="12" r="9" />, <path key="b" d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />],
  bolt: [<path key="a" d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />],
  plus: [<path key="a" d="M12 5v14M5 12h14" />],
  minus: [<path key="a" d="M5 12h14" />],
  close: [<path key="a" d="M6 6l12 12M18 6 6 18" />],
  trash: [<path key="a" d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />],
  image: [<rect key="a" x="3" y="5" width="18" height="14" rx="2" />, <path key="b" d="m3 16 5-5 4 4 3-3 6 6" />, <circle key="c" cx="16" cy="9" r="1.5" />],
  external: [<path key="a" d="M14 4h6v6M20 4l-9 9" />, <path key="b" d="M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" />],
  lock: [<rect key="a" x="5" y="11" width="14" height="10" rx="2" />, <path key="b" d="M8 11V8a4 4 0 0 1 8 0v3" />],
  info: [<circle key="a" cx="12" cy="12" r="9" />, <path key="b" d="M12 11v5M12 8h.01" />],
  percent: [<path key="a" d="M19 5 5 19" />, <circle key="b" cx="7" cy="7" r="2.5" />, <circle key="c" cx="17" cy="17" r="2.5" />],
  refresh: [<path key="a" d="M20 11a8 8 0 0 0-14.5-4.5L3 9M4 13a8 8 0 0 0 14.5 4.5L21 15" />, <path key="b" d="M3 4v5h5M21 20v-5h-5" />],
};

export const ICON_NAMES = Object.keys(ICONS);

const Icon = ({ name, size = 19, className, title, style, ...rest }) => {
  const children = ICONS[name];
  if (!children) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
      className={className}
      style={style}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
};

export default Icon;
